import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useCollaborator } from "./hooks/useCollaborator";
import { useParceiro } from "../GestaoParceirosPage/hooks/useParceiro";
import { useAuth } from "resources/AuthProvider";

import Checkbox from '@mui/material/Checkbox';
import Alert from '@mui/material/Alert';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  CircularProgress,
  Button,
  TextField,
  Card,
  CardContent,
  CardActions,
  IconButton,
} from "@mui/material";

import { 
  Edit, 
  DeleteOutline,
  KeyboardArrowLeftOutlined,
  KeyboardArrowRightOutlined,
  KeyboardDoubleArrowLeftOutlined, 
  KeyboardDoubleArrowRightOutlined,
  ToggleOffOutlined,
  ToggleOnOutlined,
  CancelOutlined,
  CheckOutlined,
  PersonAddOutlined,
  LockResetOutlined,
} from "@mui/icons-material";

import SearchSelect from "components/atoms/SearchSelect/SearchSelect";
import SelectField from "../../atoms/SelectField/SelectField";
import CpfField from "../../atoms/CpfField/CpfField";
import ConfirmDialog from "../../atoms/ConfirmDialog/ConfirmDialog";
import MultiActionButton from "../../atoms/MultiActionButton/MultiActionButton";
import { deleteUser } from "../../../API/fetchUsuarios";

import { CollaboratorType } from "../../../types/Collaborator";
import { formatarCpf } from "../../../utils/Masks";

/* Styles */
import styles from './GestaoColaboradores.module.css';
import styles_filter from "../../../styles/Filter.module.css";
import styles_input from "../../../styles/Input.module.css";
import styles_table from "../../../styles/Table.module.css";
import styles_button from "../../../styles/Button.module.css";

const label = { inputProps: { 'aria-label': 'Checkbox demo' } };

const GestaoColaboradores = () => {

  const navigate = useNavigate();
  const { hasActionPermission } = useAuth();
  const canCreateColaborador = hasActionPermission("colaboradores.create");
  const canUpdateColaborador =
    hasActionPermission("colaboradores.update_all") ||
    hasActionPermission("colaboradores.update_own");
  const canDeleteColaborador =
    hasActionPermission("colaboradores.delete_all") ||
    hasActionPermission("colaboradores.delete_own");
  const showActionsColumn = canUpdateColaborador || canDeleteColaborador;

  /*
  const { 
    msgSuccess,
    msgError,
    loading,
    parceiros,
    pagination,
    buscarParceiros,
    handleInactivatePartner,
    handleActivatePartner,
  } = useParceiro();
  */

  const {
    msgError,
    msgSuccess,
    loading,
    loadingExport,
    collaborators,
    currentPage,
    perPage,
    totalPages,
    searchCpf,
    setSearchCpf,
    searchNome,
    setSearchNome,
    searchEmail,
    setSearchEmail,
    searchInstitution,
    setSearcInstitution,
    searchStatus,
    setSearchStatus,
    openExportPdf,
    setOpenExportPdf,
    openExportXls,
    setOpenExportXls,
    setMsgError,
    setMsgSuccess,
    setCurrentPage,
    setPerPage,
    inactivateCollaborator,
    activateCollaborator,
    newPasswordCollaborator,
    recarregarColaboradores,
    inactivateMultipleCollaborators,
    activateMultipleCollaborators,
    newPasswordMultipleCollaborators,
    filterColaboradores,
    hesetFilter,
    handleExportPdf,
    handleExportXls,
  } = useCollaborator();

  const { parceirosResumo } = useParceiro(); 

  const [selectedCollaborators, setSelectedCollaborators] = useState<Set<string>>(new Set());

  const [loadingConfirmDialog, setLoadingConfirmDialog] = useState<boolean>(false);
  const [openInactivate, setOpenInactivate] = useState<boolean>(false);
  const [openActivate, setOpenActivate] = useState<boolean>(false);
  const [openNewPassword, setOpenNewPassword] = useState<boolean>(false);
  const [openMultipleInactivate, setOpenMultipleInactivate] = useState<boolean>(false);
  const [openMultipleActivate, setOpenMultipleActivate] = useState<boolean>(false);
  const [openMultipleNewPassword, setOpenMultipleNewPassword] = useState<boolean>(false);
  const [openDeleteCollaborator, setOpenDeleteCollaborator] = useState<boolean>(false);
  const [selectedCollaboratorForEdit, setSelectedCollaboratorForEdit] = useState<CollaboratorType | null>(null);

  const statusOptions = [
    { id: 1, nome: "Ativo" },
    { id: 2, nome: "Inativo" },
  ];

  // Função para lidar com a seleção de procedimentos para fechamento
  const handleCollaboratorSelection = (id: string | number) => {
    const procedureId: string = String(id);

    setSelectedCollaborators(prevSelected => {
      const newSelected = new Set(prevSelected);
      if (newSelected.has(procedureId)) {
        newSelected.delete(procedureId);
      } else {
        newSelected.add(procedureId);
      }
      return newSelected;
    });
  };

  const handleEditCollaborator = (id :number) => {
    navigate(`/colaborador?id=${id}`);
  };

  const handleNewCollaborator = () => {
    navigate(`/colaborador`);
  };

  const handleOpenInactivateCollaborator = (collaborator: CollaboratorType) => {
    setSelectedCollaboratorForEdit(collaborator);
    setOpenInactivate(true);
  };

  const handleOpenActivateCollaborator = (collaborator: CollaboratorType) => {
    setSelectedCollaboratorForEdit(collaborator);
    setOpenActivate(true);
  };

  const handleOpenNewPassword = (collaborator: CollaboratorType) => {
    setSelectedCollaboratorForEdit(collaborator);
    setOpenNewPassword(true);
  };

  const handleOpenDeleteCollaborator = (collaborator: CollaboratorType) => {
    setSelectedCollaboratorForEdit(collaborator);
    setOpenDeleteCollaborator(true);
  };

  const handleInactivateCollaborador = async () => {
    try {
      if (!selectedCollaboratorForEdit) {
        return;
      }
      setLoadingConfirmDialog(true);
      await inactivateCollaborator(selectedCollaboratorForEdit.id);
      setLoadingConfirmDialog(false);
      setOpenInactivate(false);
      recarregarColaboradores();
      setMsgSuccess('Colaborador inativado com sucesso!');
    } catch (error) {
      setLoadingConfirmDialog(false);
      setOpenInactivate(false);
      setMsgError('Não foi possível inativar o colaborador!');
    }
  };

  const handleActivateCollaborator = async () => {
     try {
      if (!selectedCollaboratorForEdit) {
        return;
      }
      setLoadingConfirmDialog(true);
      await activateCollaborator(selectedCollaboratorForEdit.id);
      setLoadingConfirmDialog(false);
      setOpenActivate(false);
      recarregarColaboradores();
      setMsgSuccess('Colaborador reativado com sucesso!');
    } catch (error) {
      setLoadingConfirmDialog(false);
      setOpenActivate(false);
      setMsgError('Não foi possível reativar o colaborador!');
    }
  };

  const handleSendTemporaryPassword = async () => {
     try {
      if (!selectedCollaboratorForEdit) {
        return;
      }
      setLoadingConfirmDialog(true);
      await newPasswordCollaborator(selectedCollaboratorForEdit.id);
      setLoadingConfirmDialog(false);
      setOpenNewPassword(false);
      recarregarColaboradores();
      setMsgSuccess('Senha temporária enviada com sucesso!');
    } catch (error) {
      setLoadingConfirmDialog(false);
      setOpenNewPassword(false);
      setMsgError('Não foi possível enviar a senha temporária!');
    }
  };

  const handleInactivateMultipleCollaborators = async () => {
    try {
      setLoadingConfirmDialog(true);
      const stringArray = Array.from(selectedCollaborators);
      const numberArray = stringArray.map(item => Number(item));
      
      await inactivateMultipleCollaborators(numberArray);
      setMsgSuccess('Colaboradores inativados com sucesso!');

      setLoadingConfirmDialog(false);
      recarregarColaboradores();
      setOpenMultipleInactivate(false);
      setSelectedCollaborators(new Set());
      
    } catch (error) {
      setLoadingConfirmDialog(false);
      setOpenMultipleInactivate(false);
      setMsgError('Não foi possível inativar os colaboradores!');
    }
  };

  const handleActivateMultipleCollaborators = async () => {
    try {
      setLoadingConfirmDialog(true);
      const stringArray = Array.from(selectedCollaborators);
      const numberArray = stringArray.map(item => Number(item));
      
      await activateMultipleCollaborators(numberArray);
      setMsgSuccess('Colaboradores reativados com sucesso!');

      setLoadingConfirmDialog(false);
      recarregarColaboradores();
      setOpenMultipleActivate(false);
      setSelectedCollaborators(new Set());
      
    } catch (error) {
      setLoadingConfirmDialog(false);
      setOpenMultipleActivate(false);
      setMsgError('Não foi possível reativar os colaboradores!');
    }
  };

  const handleNewPasswordMultipleCollaborators = async () => {
    try {
      setLoadingConfirmDialog(true);
      const stringArray = Array.from(selectedCollaborators);
      const numberArray = stringArray.map(item => Number(item));
      
      await newPasswordMultipleCollaborators(numberArray);
      setMsgSuccess('Senhas temporárias enviadas com sucesso!');

      setLoadingConfirmDialog(false);
      recarregarColaboradores();
      setOpenMultipleNewPassword(false);
      setSelectedCollaborators(new Set());
      
    } catch (error) {
      setLoadingConfirmDialog(false);
      setOpenMultipleNewPassword(false);
      setMsgError('Não foi possível enviar as senhas temporárias!');
    }
  };

  const handleDeleteCollaborator = async () => {
    try {
      if (!selectedCollaboratorForEdit) {
        return;
      }
      setLoadingConfirmDialog(true);
      const message = await deleteUser(selectedCollaboratorForEdit.id);
      setLoadingConfirmDialog(false);
      setOpenDeleteCollaborator(false);
      setSelectedCollaboratorForEdit(null);
      recarregarColaboradores();
      setMsgSuccess(message);
    } catch (error) {
      setLoadingConfirmDialog(false);
      setOpenDeleteCollaborator(false);
      setMsgError('não foi possível excluir o colaborador!');
    }
  };

  return (
    <Card className={styles.card}>
      <CardContent>
        <div className={styles.title}>
          Gestão de Parceiros - Colaboradores Eventuais/Parceiros
        </div>
        <div className={styles_filter.container}>
          <div className={styles_filter.grid12}>
            <div className={styles_filter.inputGroup4}>
              <label className={styles_input.titleInput}>
                Nome do Colaborador
              </label>
              <TextField
                size="small"
                placeholder=""
                variant="standard"
                autoFocus={false}
                fullWidth
                data-testid="nome"
                value={searchNome}
                onChange={(e) => setSearchNome(e.target.value)}
                required
                inputProps={{ maxLength: 150 }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  className: styles_input.input,
                  disableUnderline: true,
                }}
              />
            </div>

            <div className={styles_filter.inputGroup4}>
              <label className={styles_input.titleInput}>
                CPF
              </label>
              <CpfField
                size="small"
                placeholder=""
                variant="standard"
                autoFocus={false}
                value={searchCpf ?? ""}
                onUpdate={(value) => setSearchCpf(value)}
                customClassName={styles_input.input}
              />
            </div>

            <div className={styles_filter.inputGroup4}>
              <label className={styles_input.titleInput}>
                E-mail
              </label>
              <TextField
                size="small"
                placeholder=""
                variant="standard"
                autoFocus={false}
                fullWidth
                data-testid="nome"
                value={searchEmail}
                onChange={(e) => setSearchEmail(e.target.value)}
                required
                inputProps={{ maxLength: 150 }}
                InputLabelProps={{
                  shrink: true,
                }}
                InputProps={{
                  className: styles_input.input,
                }}
                sx={{
                  '& .MuiInput-underline:before': { borderBottom: 'none' },
                  '& .MuiInput-underline:after': { borderBottom: 'none' },
                  '& .MuiInput-underline:hover:not(.Mui-disabled):before': { borderBottom: 'none' },
                }}
              />
            </div>

            <div className={styles_filter.inputGroup4}>
              <label className={styles_input.titleInput}>
                Instituição Vinculada
              </label>
              <SearchSelect
                label=""
                key="institution_id"
                options={parceirosResumo}
                value={searchInstitution}
                onChange={(id) => {setSearcInstitution(id);}}
                paperClassname={styles_input.paper}
                popperClassname={styles_input.popper}
                labelClassname={styles_input.labelSelect}
                inputClassname={styles_input.inputSelect}
              />
            </div>

            <div className={styles_filter.inputGroup3}>
              <label className={styles_input.titleInput}>
                Status
              </label>
              <SearchSelect
                label=""
                key="status_filter"
                options={statusOptions}
                value={searchStatus ?? null}
                onChange={(id) => {setSearchStatus(id ?? undefined);}}
                paperClassname={styles_input.paper}
                popperClassname={styles_input.popper}
                labelClassname={styles_input.labelSelect}
                inputClassname={styles_input.inputSelect}
              />
            </div>

            <div className={styles_filter.inputGroup5}>
              <div className={styles_filter.containerButton}>
                <div className={styles_filter.lineButton}>
                  {/* Limpar */}
                  <Button 
                    variant="contained"
                    onClick={hesetFilter} 
                    className={styles_filter.buttonClean}
                    color="primary"
                  >
                    Limpar
                  </Button>
                  
                  {/* Pesquisar */}
                  <Button
                    variant="contained"
                    onClick={filterColaboradores}
                    className={styles_filter.buttonSearch}
                    color="primary"
                  >
                    Pesquisar
                  </Button>
                </div>

                <div className={styles_filter.lineButton}>
                  <Button
                    variant="contained"
                    className={styles_filter.buttonXls}
                    color="primary"
                    onClick={() => setOpenExportXls(true)}
                  >
                    Gerar XLS
                  </Button>

                  <Button
                    variant="contained"
                    className={styles_filter.buttonPdf}
                    color="primary"
                    onClick={() => setOpenExportPdf(true)}
                  >
                    Gerar PDF
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {msgSuccess && (
          <div className={styles_table.message}>
            <Alert severity="success">
              {msgSuccess}
            </Alert>
          </div>
        )}
        {msgError && (
          <div className={styles_table.message}>
            <Alert severity="error">
              {msgError}
            </Alert>
          </div>
        )}

        <div className={styles_table.actionsMass}>
          {canCreateColaborador && (
            <Button
              className={styles_button.buttonPrimary}
              variant="outlined"
              startIcon={<PersonAddOutlined />}
              onClick={handleNewCollaborator}
            >
              Cadastrar Colaborador Eventual
            </Button>
          )}

          {canUpdateColaborador && selectedCollaborators.size > 0 && (
            <MultiActionButton
              buttonLabel="Ações em Massa"
              actions={[
                {
                  label: "Reenviar Senhas",
                  icon: <LockResetOutlined />,
                  onClick: () => setOpenMultipleNewPassword(true),
                },
                {
                  label: "Inativar Colaboradores",
                  icon: <CancelOutlined />,
                  onClick: () => setOpenMultipleInactivate(true),
                },
                {
                  label: "Reativar Colaboradores",
                  icon: <CheckOutlined />,
                  onClick: () => setOpenMultipleActivate(true),
                },
              ]}
            />
          )}
        </div>

        <TableContainer className={styles_table.tableContainer}>
          {loading ? (
            <CircularProgress />
          ) : (
            <Table size="small">
              <TableHead className={styles_table.tableHead}>
                <TableRow>
                  {canUpdateColaborador && <TableCell padding="none" className={styles_table.tableHeadRow}></TableCell>}
                  <TableCell padding="none" className={styles_table.tableHeadRow} align="left">Nome do Colaborador</TableCell>
                  <TableCell padding="none" className={styles_table.tableHeadRow} align="left">CPF</TableCell>
                  <TableCell padding="none" className={styles_table.tableHeadRow}>E-mail</TableCell>
                  <TableCell padding="none" className={styles_table.tableHeadRow}>Instituição Vinculada</TableCell>
                  <TableCell padding="none" className={styles_table.tableHeadRow} align="center">Status</TableCell>
                  {showActionsColumn && <TableCell padding="none" className={styles_table.tableHeadRow} align="center">Ações</TableCell>}
                </TableRow>
              </TableHead>
              <TableBody>
                {collaborators.map((colaborador, index) => (
                  <TableRow
                    key={colaborador.id}
                    className={`${styles_table.tableRow} ${index % 2 === 0 ? styles_table.tableRowEven : styles_table.tableRowOdd}`}
                  >
                    {canUpdateColaborador && (
                      <TableCell padding="none">
                        <Checkbox {...label}
                          checked={selectedCollaborators.has(String(colaborador.id))}
                          onChange={() => handleCollaboratorSelection(colaborador.id)}
                        />
                      </TableCell>
                    )}
                    <TableCell padding="none" className={styles_table.textXs} align="left">{colaborador.nome}</TableCell>
                    <TableCell padding="none" className={styles_table.textXs}>
                      {formatarCpf(colaborador.cpf)}
                    </TableCell>
                    <TableCell padding="none" className={styles_table.textXs}>{colaborador.email}</TableCell>
                    <TableCell padding="none" className={styles_table.textXs}>{colaborador.instituicoes.length > 0 ? colaborador.instituicoes[0].nome : 'Sem Instituição Vinculada'}</TableCell>
                    <TableCell padding="none" className={styles_table.textXs} align="center">{colaborador.ativo ? "Ativo" : "Inativo"}</TableCell>
                    {showActionsColumn && (
                      <TableCell padding="none">
                        <div className={styles_table.blockActions}>
                          {canUpdateColaborador && (
                            <IconButton
                              size="small"
                              color="primary"
                              aria-label="Editar Parceiro"
                              disabled={selectedCollaborators.size > 0 || !colaborador.ativo ? true : false}
                              onClick={() => handleEditCollaborator(colaborador.id)}>
                              <Edit fontSize="small" />
                            </IconButton>
                          )}

                          {canUpdateColaborador && (
                            <IconButton
                              size="small"
                              color="primary"
                              aria-label="Gerar nova senha"
                              disabled={selectedCollaborators.size > 0 || !colaborador.ativo ? true : false}
                              onClick={() => handleOpenNewPassword(colaborador)}
                            >
                              <LockResetOutlined fontSize="small" />
                            </IconButton>
                          )}

                          {canUpdateColaborador && colaborador.ativo ? (
                          
                          <IconButton 
                            size="small"
                            color="primary" 
                            aria-label="Inativar Parceiro" 
                            disabled={selectedCollaborators.size > 0 ? true : false}
                            onClick={() => handleOpenInactivateCollaborator(colaborador)}
                          >
                            <ToggleOnOutlined fontSize="small" />
                          </IconButton>

                          ) : canUpdateColaborador ? (

                          <IconButton 
                            size="small"
                            color="primary" 
                            aria-label="Ativar Usuário" 
                            disabled={selectedCollaborators.size > 0 ? true : false}
                            onClick={() => handleOpenActivateCollaborator(colaborador)}
                          >
                            <ToggleOffOutlined fontSize="small" />
                          </IconButton>

                          ) : null}

                          {canDeleteColaborador && (
                            <IconButton
                              size="small"
                              color="error"
                              aria-label="Excluir Colaborador"
                              disabled={selectedCollaborators.size > 0 ? true : false}
                              onClick={() => handleOpenDeleteCollaborator(colaborador)}
                            >
                              <DeleteOutline fontSize="small" />
                            </IconButton>
                          )}

                        </div>
                      </TableCell>
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          )}


          <ConfirmDialog
            open={openInactivate}
            loading={loadingConfirmDialog}
            onClose={() => setOpenInactivate(false)}
            onConfirm={() => handleInactivateCollaborador()}
            title="Inativar colaborador!"
            message={`Deseja realmente inativar o colaborador "${selectedCollaboratorForEdit?.nome}"?`}
            titleLoadButton="Inativando..."
            titleButtonConfirm="Inativar"
          />

          <ConfirmDialog
            open={openActivate}
            loading={loadingConfirmDialog}
            onClose={() => setOpenActivate(false)}
            onConfirm={() => handleActivateCollaborator()}
            title="Reativar colaborador!"
            message={`Deseja realmente reativar o colaborador "${selectedCollaboratorForEdit?.nome}"?`}
            titleLoadButton="Reativando..."
            titleButtonConfirm="Reativar"
          />

          <ConfirmDialog
            open={openNewPassword}
            loading={loadingConfirmDialog}
            onClose={() => setOpenNewPassword(false)}
            onConfirm={() => handleSendTemporaryPassword()}
            title="Enviar nova senha!"
            message={`Confirmar o envio da senha temporária para "${selectedCollaboratorForEdit?.nome}"?`}
            titleLoadButton="Enviando..."
          />

          <ConfirmDialog
            open={openDeleteCollaborator}
            loading={loadingConfirmDialog}
            onClose={() => setOpenDeleteCollaborator(false)}
            onConfirm={() => handleDeleteCollaborator()}
            title="Excluir colaborador"
            message={`Deseja realmente excluir o colaborador "${selectedCollaboratorForEdit?.nome}"?`}
            titleLoadButton="Excluindo..."
            titleButtonConfirm="Excluir"
          />

          <ConfirmDialog
            open={openMultipleInactivate}
            loading={loadingConfirmDialog}
            onClose={() => setOpenMultipleInactivate(false)}
            onConfirm={() => handleInactivateMultipleCollaborators()}
            title="Inativar colaboradores"
            message={`Deseja realmente inativar os colaboradores selecionados?`}
            titleLoadButton="Inativando..."
            titleButtonConfirm="Inativar"
          />

          <ConfirmDialog
            open={openMultipleActivate}
            loading={loadingConfirmDialog}
            onClose={() => setOpenMultipleActivate(false)}
            onConfirm={() => handleActivateMultipleCollaborators()}
            title="Reativar Instituições"
            message={`Deseja realmente reativar os colaboradores selecionados?`}
            titleLoadButton="Inativando..."
            titleButtonConfirm="Inativar"
          />

          <ConfirmDialog
            open={openMultipleNewPassword}
            loading={loadingConfirmDialog}
            onClose={() => setOpenMultipleNewPassword(false)}
            onConfirm={() => handleNewPasswordMultipleCollaborators()}
            title="Reenviar Senhas"
            message={`Deseja realmente reenviar a senha para os colaboradores selecionados?`}
            titleLoadButton="Enviando..."
            titleButtonConfirm="Enviar"
          />

          <ConfirmDialog
            open={openExportPdf}
            loading={loadingExport}
            onClose={() => setOpenExportPdf(false)}
            onConfirm={() => handleExportPdf()}
            title="Exportar usuários em PDF"
            message={`Deseja confirmar a exportação dos usuários em PDF?`}
            titleLoadButton="Exportando..."
            titleButtonConfirm="Exportar"
          />

          <ConfirmDialog
            open={openExportXls}
            loading={loadingExport}
            onClose={() => setOpenExportXls(false)}
            onConfirm={() => handleExportXls()}
            title="Exportar usuários em XLS"
            message={`Deseja confirmar a exportação dos usuários em XLS?`}
            titleLoadButton="Exportando..."
            titleButtonConfirm="Exportar"
          />

        </TableContainer>
      </CardContent>

      {/* Inicio Bloco Paginação */}
      <CardActions className={styles_table.containerPagination}>
        <div className={styles_table.qtdItems}>
          <div className={styles_table.labelSelect}>
            Resultados por página
          </div>
          <SelectField
            label=""
            value={perPage.toString() || ""}
            onChange={(value) => setPerPage(Number(value))}
            options={[{ nome: "10" }, { nome: "20" }, { nome: "30" }]}
            disableClearable
            disableTyping
          />
        </div>
        <div className={styles_table.pagination}>

          <IconButton 
            className={currentPage === 1 ? styles_table.iconButtonPageDisabled : styles_table.iconButtonPage} 
            aria-label="Primeira Página" 
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(1)}
          >
            <KeyboardDoubleArrowLeftOutlined />
          </IconButton>

          <IconButton 
            className={currentPage === 1 ? styles_table.iconButtonPageDisabled : styles_table.iconButtonPage}
            aria-label="Página Anterior" 
            disabled={currentPage === 1}
            onClick={() => setCurrentPage(currentPage - 1)}
          >
            <KeyboardArrowLeftOutlined />
          </IconButton>
          <span className={styles_table.pages}>
            Página {currentPage} de {totalPages}
          </span>
    
          <IconButton 
            className={currentPage === totalPages ? styles_table.iconButtonPageDisabled : styles_table.iconButtonPage}
            aria-label="Próxima Página" 
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(currentPage + 1)}
          >
            <KeyboardArrowRightOutlined />
          </IconButton>

          <IconButton 
            className={currentPage === totalPages ? styles_table.iconButtonPageDisabled : styles_table.iconButtonPage}
            aria-label="Primeira Página" 
            disabled={currentPage === totalPages}
            onClick={() => setCurrentPage(totalPages)}
          >
            <KeyboardDoubleArrowRightOutlined />
          </IconButton>
  
        </div>

        <div className={styles_table.setNumberPage}>
          <div className={styles_table.labelSelect}>
            Ir para a página
          </div>
          <SelectField
            label=""
            value={currentPage.toString() || ""}
            onChange={(value) => setCurrentPage(Number(value))}
            options={Array.from({ length: totalPages }, (_, index) => ({
              nome: String(index + 1) 
            }))}
            disableTyping
          />
        </div>

      </CardActions>
      {/* Fim Bloco Paginação */}

    </Card>
  );
};

export default GestaoColaboradores;
